import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { FileRepository } from '@front/repository/Api/File';
import { useMutation } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import type { CsvAnalysis } from 'troppus-common/shared';

import Project = AuthDomain.Object.Project;

const repository = new FileRepository();

export type _AnalyzeCsvVariables = {
  projectId: Project.Id;
  fileId: string;
  signal?: AbortSignal;
};

export type _AnalyzeCsvResult = {
  analysis: CsvAnalysis;
};

/**
 * アップロード済みファイルに対して `/files/analyze` を呼び `CsvAnalysis` を取得する。
 * サーバ側で FeatureFlag を参照して推定エンジン（キーワード / Vertex LLM）が切り替わるが、
 * フロントはエンジンを意識せず常に同一のレスポンス shape のみを扱う。
 */
export const _useAnalyzeCsv = () => {
  return useMutation({
    mutationFn: async (params: _AnalyzeCsvVariables): Promise<_AnalyzeCsvResult> => {
      const analysis = await repository.analyzeCsv(
        { projectId: params.projectId, fileId: params.fileId },
        { signal: params.signal ?? signalToTimeout(DEFAULT_TIMEOUT.MUTATION) },
      );
      return { analysis };
    },
    ...UseMutationDefaultOptions,
  });
};
